import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-439e79e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"height":"100%"},
  class: "siderbar"
}
const _hoisted_2 = { class: "flex-center" }
const _hoisted_3 = { style: {"text-align":"center","color":"#74798c"} }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("span", null, "扫描二维码，添加管家微信"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "获得人工帮助")
], -1))

import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import appConfig from "@/config/config";
import { ElMessage, ElMessageBox } from "element-plus";
import axios from "@/utils/axios.js";
import mitt from "@/service/mitt.js";
import { getLocal } from "@/service/common.js";


export default /*#__PURE__*/_defineComponent({
  __name: 'SideBar',
  setup(__props) {

const router = useRouter();
const store = useStore();
const menuRef = ref(null);
const apptitle = appConfig.title;
const checkNum = ref(); // 用户剩余次数

// 退出系统
const logout = () => {
  ElMessageBox.confirm("确定退出系统吗？", "提示", {
    confirmButtonText: "确定",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      axios
        .get("/logout")
        .then((resp) => {
          if (resp && resp.code && resp.code == 200) {
            router.push("/login");
            store.commit("clearAuth");
          } else {
            ElMessage.error(resp.msg);
          }
        })
        .catch((err) => {
          // console.log(err);
        });
    })
    .catch((e) => {
      // console.log(e);
    });
};

const getcheckNum = () => {
  //接收传值
  mitt.on("checkNum", (val) => {
    checkNum.value = val;
  });
  checkNum.value = getLocal("checkNum");
};

onMounted(() => {
  getcheckNum();
});

return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_homeIcon = _resolveComponent("homeIcon")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_FolderChecked = _resolveComponent("FolderChecked")!
  const _component_historyIcon = _resolveComponent("historyIcon")!
  const _component_wordIcon = _resolveComponent("wordIcon")!
  const _component_permissionsIcon = _resolveComponent("permissionsIcon")!
  const _component_helpcenterIcon = _resolveComponent("helpcenterIcon")!
  const _component_logoutIcon = _resolveComponent("logoutIcon")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_headset_oneIcon = _resolveComponent("headset-oneIcon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_send_emailIcon = _resolveComponent("send-emailIcon")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_ctx.$route.meta.loginRequest)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: _unref(store).state.openMenu ? 35 : 20,
            src: require('@/assets/img/logo.svg'),
            fit: "contain",
            class: _normalizeClass(_unref(store).state.openMenu ? 'w150' : 'w100')
          }, null, 8, ["size", "src", "class"])
        ]),
        (!_ctx.$route.meta.project)
          ? (_openBlock(), _createBlock(_component_el_menu, {
              key: 0,
              ref_key: "menuRef",
              ref: menuRef,
              collapse: !_unref(store).state.openMenu,
              "default-active": _ctx.$route.path,
              class: "el-menu-vertical-demo",
              "active-text-color": "#0054fe",
              "text-color": "#909399",
              "unique-opened": true,
              router: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_menu_item, { index: '/index' }, {
                  title: _withCtx(() => [
                    _createTextVNode("首页")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_homeIcon)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: '/paper_detection' }, {
                  title: _withCtx(() => [
                    _createTextVNode("论文检测")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_FolderChecked)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: '/history' }, {
                  title: _withCtx(() => [
                    _createTextVNode("历史记录")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_historyIcon)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: '/thesis_assistant' }, {
                  title: _withCtx(() => [
                    _createTextVNode("论文助手")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_wordIcon)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: '/personal_center' }, {
                  title: _withCtx(() => [
                    _createTextVNode("个人中心")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_permissionsIcon)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, { index: '/help_center' }, {
                  title: _withCtx(() => [
                    _createTextVNode("帮助中心")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_helpcenterIcon)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_menu_item, {
                  index: "",
                  onClick: logout
                }, {
                  title: _withCtx(() => [
                    _createTextVNode("退出系统")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_logoutIcon)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["collapse", "default-active"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_row, { class: "contact" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_text, { class: "" }, {
              default: _withCtx(() => [
                _createTextVNode("剩余次数："),
                _createElementVNode("b", null, _toDisplayString(checkNum.value), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_popover, {
                  placement: "top-start",
                  width: 200,
                  trigger: "hover"
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_el_link, { underline: false }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_headset_oneIcon)
                          ]),
                          _: 1
                        }),
                        _createTextVNode("联系客服")
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _hoisted_4,
                      _createVNode(_component_el_image, {
                        style: {"width":"100px","height":"100px"},
                        src: require('../assets/img/weixin.png'),
                        fit: "cover"
                      }, null, 8, ["src"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_link, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/help_center'))),
                  underline: false
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_send_emailIcon)
                      ]),
                      _: 1
                    }),
                    _createTextVNode("意见反馈")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})